import { Traffic } from 'core/types/traffic';

import { Action, SET_TRAFFIC } from './actions';

export default (state: Traffic[] = [], action: Action) => {
  switch (action.type) {
    case SET_TRAFFIC:
      return action.payload;
    default:
      return state;
  }
};
